<input
  #telInputRef
  id="phone"
  type="tel"
  [ngModel]="value"
  [placeholder]="placeholder() || ''"
  [class.error]="!isDisabled && errorMessage"
  [disabled]="isDisabled"
  (ngModelChange)="handleUpdateValue($event)"
  (blur)="handleFocus()"
  />
@if (!isDisabled && showErrors() && errorMessage && isTouched) {
  <div class="input-error">
    {{ errorMessage }}
  </div>
}
